import {
	Container,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { useDisclaimers } from '../../../../../../../context/disclaimers-context';
import { huchaLinesColor } from '../../../../../../../helpers/color-tokens';
import { handleScrollToDisclaimer } from '../../../../../../../helpers/disclaimers/disclaimers-utils';
import { HuchaDisclaimer1Text } from '../../disclaimers/hucha-disclaimers';

const MainContainerDiv = styled.div`
	display: flex;
	width: 100%;
`;

const StyledC2Wrapper = styled.div`
	flex: 1;

	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	align-content: center;
	padding: var(--size-dynamic0100) 4px;
`;

const StyledAmountText = styled.div`
	display: flex;
	align-items: end;

	& * {
		line-height: 100%;
		font-family: var(--font-family-head);
		font-weight: 100;
	}

	& [data-testid='hucha-amount'] {
		font-size: clamp(90px, 4.6rem + 5vw, 112px);

		@media (min-width: 1230px) {
			font-size: clamp(90px, 3.6rem + 3vw, 112px);
		}
	}
	& [data-testid='hucha-currency'] {
		font-size: clamp(60px, 2rem + 2.5vw, 90px);
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 20px;
`;

export const HuchaStandardCardC2 = ({ dineroHucha }: { dineroHucha: string }) => {
	const { findBadge } = useDisclaimers();
	const badge = findBadge(HuchaDisclaimer1Text);

	return (
		<MainContainerDiv data-testid="card-c2-container">
			<StyledC2Wrapper>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.center}
					bold
				>
					{'Llevas acumulado'}
				</Text>
				<Container wrap="never" horizontalAlign="center">
					<Container wrap="never" verticalAlign="flex-end">
						<StyledAmountText>
							<Text data-testid="hucha-amount" color={TokenTextColor.inverted}>
								{dineroHucha}
							</Text>
							<Text data-testid="hucha-currency" color={TokenTextColor.inverted}>
								{'€'}
							</Text>
						</StyledAmountText>
					</Container>
					{badge && (
						<StyledReferenceBadge
							variant="large"
							onClick={() => {
								if (badge) handleScrollToDisclaimer(badge);
							}}
						>
							{badge.replace(/\.$/, '')}
						</StyledReferenceBadge>
					)}
				</Container>
			</StyledC2Wrapper>
		</MainContainerDiv>
	);
};
